import React from "react";

const GuessResultList = ({ results, rowTemplate: RowTemplate }) => {
  return (
    <div className="grid w-full grid-cols-7 gap-1 text-center">
      {results?.map((_row, _idx) => (
        <RowTemplate key={"guess-result-" + _idx} {..._row} />
      ))}
    </div>
  );
};

export default GuessResultList;
